import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { AppraisalMap } from './index';

const map = {
  start_new_appraisal: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_APPRAISE_VEHICLE,
    TrackingConstant.SUBACTION_START_NEW_APPRAISAL
  ),
};

export const AppraiserChannelMap = {
  ...AppraisalMap,
  ...map,
};
